import * as Actions from '../actions';

const initialState = {
    tokenValid: false
}

const passwordreset = function (state = initialState, action) {
    switch ( action.type )
    {
        case(Actions.CHECK_TOKEN_VALID):
        {
            return {
                ...state,
                tokenValid: action.payload
            }
        }
        default:
        {
            return state
        }
    }

};

export default passwordreset;


// WEBPACK FOOTER //
// src/auth/store/reducers/passwordreset.reducer.js